import { render, staticRenderFns } from "./WaitingOrder.vue?vue&type=template&id=215311f1&"
import script from "./WaitingOrder.vue?vue&type=script&lang=js&"
export * from "./WaitingOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports